<main>
  <!-- Hero Section -->
  <section
    class="bg-[url('/assets/images/Model3_53.webp')] bg-cover bg-center bg-blend-multiply bg-black/50 min-h-[40vh] flex flex-col justify-center items-center text-white px-3 md:px-5 2xl:px-28 3xl:px-52"
  >
    <div
      class="container flex flex-col justify-center items-center text-center"
    >
      <h1 class="text-3xl lg:text-5xl font-extrabold text-center mb-3">
        Frequently Asked Questions
      </h1>
      <p class="text-white font-semibold text-center text-lg lg:text-xl">
        Answers to Your Most Common Questions About Only Used Tesla
      </p>
    </div>
  </section>

  <!-- FAQ1 -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16">
    <div
      class="container mx-auto flex flex-col-reverse lg:flex-row items-center justify-center gap-5 lg:gap-10"
    >
      <!-- Text -->
      <div class="lg:basis-[50%]">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          Do I have to pay the site to buy a Tesla from this site?
        </h2>
        <p>
          No. All negotiations, payments, and contracts occur strictly between
          you and the seller. It’s free to register and to search for used
          Teslas, and there are no hidden fees.
        </p>
      </div>
      <!-- Image -->
      <div
        class="relative lg:basis-[50%] 2xl:max-h-[40vh] rounded-lg overflow-hidden"
      >
        <img
          src="/assets/images/OUT-tesla-2.jpg"
          alt="hero_image"
          class="h-full w-full object-cover"
        />
      </div>
    </div>
  </section>

  <!-- FAQ2 -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16 bg-gray-50">
    <div
      class="container mx-auto flex flex-col lg:flex-row items-center justify-center gap-5 lg:gap-10"
    >
      <!-- Image -->
      <div class="relative lg:basis-[50%] rounded-lg overflow-hidden">
        <img
          src="/assets/images/OUT-tesla-3.jpg"
          alt="hero_image"
          class="h-full w-full object-cover 2xl:max-h-[45vh]"
        />
      </div>
      <!-- Text -->
      <div class="lg:basis-[50%]">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          How much does it cost for me to list my used Tesla ad here?
        </h2>
        <ol class="list-disc pl-5">
          <li>UPFRONT COST TO LIST IS $47</li>
          <li>NO HIDDEN BS</li>
        </ol>
      </div>
    </div>
  </section>

  <!-- FAQ3 -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16">
    <div
      class="container mx-auto flex flex-col-reverse lg:flex-row items-center justify-center gap-5 lg:gap-10"
    >
      <!-- Text -->
      <div class="lg:basis-[50%]">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          What exactly do I get for the $100 Facebook Promotional Fee?
        </h2>
        <p>
          The optional $100 fee includes management, targeting, and
          complimentary analytics, and each post is specifically targeted to
          active buyers in your area, and who are interested in your specific
          model.
        </p>
      </div>
      <!-- Image -->
      <div class="relative lg:basis-[50%] rounded-lg overflow-hidden">
        <img
          src="/assets/images/OUT-tesla-7.png"
          alt="hero_image"
          class="h-full w-full 2xl:max-h-[50vh] object-cover"
        />
      </div>
    </div>
  </section>

  <!-- FAQ4 -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16 bg-gray-50">
    <div
      class="container mx-auto flex flex-col lg:flex-row items-center justify-center gap-5 lg:gap-10"
    >
      <!-- Image -->
      <div class="relative lg:basis-[50%] rounded-lg overflow-hidden">
        <img
          src="/assets/images/OUT-tesla-4.jpg"
          alt="hero_image"
          class="h-full w-full object-cover"
        />
      </div>
      <!-- Text -->
      <div class="lg:basis-[50%]">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          Why would I pay someone to run a Facebook promotion when I already
          have Facebook?
        </h2>
        <p>
          <a
            href="https://www.nbcnews.com/technolog/smartphone-users-check-facebook-14-times-day-study-says-1C9125315"
            target="_blank"
            class="text-blue-600"
            >The average cell phone user checks Facebook 14 times a day.</a
          >
          In addition, Facebook user targeting is incredibly precise, allowing
          us to serve your listing to people who are actively in the market for
          the exact model you’re selling. This guarantees your vehicle listing
          will be seen by hundreds of more interested buyers in your area,
          giving you more options and a faster sale. We lend our name and
          credibility to your posting, and handle all the tricky technical
          backend details that can sometimes lead to costly mistakes.
        </p>
      </div>
    </div>
  </section>

  <!-- FAQ5 -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16">
    <div
      class="container mx-auto flex flex-col-reverse lg:flex-row items-center justify-center gap-5 lg:gap-10"
    >
      <!-- Text -->
      <div class="lg:basis-[50%]">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          How do I know if the buyer/seller is being honest?
        </h2>
        <p>
          In the future, we’ll be implementing a video chat feature that will
          help by letting you see the buyer, seller, or used Tesla live. Until
          then, we recommend you use a third party service such as Skype for
          video chats. You can also ask for the seller to provide proof of the
          Extended Service Agreement (ESA), if applicable. If you’re ever unsure
          of the integrity of the person your dealing with, or the vehicle in
          question, don’t sign anything. Be careful, communicate frequently, and
          trust your intuition.
        </p>
      </div>
      <!-- Image -->
      <div class="relative lg:basis-[50%] rounded-lg overflow-hidden">
        <img
          src="/assets/images/OUT-tesla-6.png"
          alt="hero_image"
          class="h-full w-full object-cover"
        />
      </div>
    </div>
  </section>

  <!-- FAQ6 -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16 bg-gray-50">
    <div
      class="container mx-auto flex flex-col lg:flex-row items-center justify-center gap-5 lg:gap-10"
    >
      <!-- Image -->
      <div class="relative lg:basis-[50%] rounded-lg overflow-hidden">
        <img
          src="/assets/images/OUT-tesla-5.jpg"
          alt="hero_image"
          class="h-full w-full object-cover"
        />
      </div>
      <!-- Text -->
      <div class="lg:basis-[50%]">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          How do I get more information from the buyer/seller?
        </h2>
        <p>
          In some cases buyers and sellers may choose to provide you with their
          personal contact information to facilitate the process, and in the
          future, we’ll be implementing video chat and messaging features for
          users. At the moment, if you’re interested in keeping your contact
          information private, we recommend using a third party app such as
          Skype.
        </p>
      </div>
    </div>
  </section>
  <!-- FAQ7 -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16">
    <div
      class="container mx-auto flex flex-col-reverse lg:flex-row items-center justify-center gap-5 lg:gap-10"
    >
      <!-- Text -->
      <div class="lg:basis-[50%]">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          How is the used Tesla picked up/delivered?
        </h2>
        <p>
          The buyer and seller arrange this with each other as part of the
          purchase. In most cases, the cost of transporting the used Tesla is a
          separate cost from the purchase price, and you should take the time to
          discuss these details before you sign anything. We stay out of your
          purchase.
        </p>
      </div>
      <!-- Image -->
      <div class="relative lg:basis-[50%] rounded-lg overflow-hidden">
        <img
          src="/assets/images/Group_91.webp"
          alt="hero_image"
          class="h-full w-full object-cover"
        />
      </div>
    </div>
  </section>
  <!-- FAQ Form -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16 bg-gray-50">
    <div
      class="container mx-auto flex flex-col lg:flex-row items-center justify-center gap-5 lg:gap-7"
    >
      <div
        class="relative w-full lg:basis-[50%] h-full rounded-lg overflow-hidden"
      >
        <img
          src="/assets/images/faq.avif"
          alt="hero_image"
          class="h-full w-full max-h-[50vh] xl:max-h-[70vh] rounded-lg object-cover object-center"
        />
      </div>
      <div class="lg:w-[50%] flex flex-col gap-3 px-4">
        <div>
          <h4 class="text-3xl lg:text-4xl font-bold">Got a Question?</h4>
          <p>
            Submit your question below, and we'll get back to you as soon as
            possible.
          </p>
        </div>
        <section class="flex flex-col gap-y-5 xl:gap-y-7">
          <!-- Form -->
          <form (ngSubmit)="onSubmit()" [formGroup]="faqForm" novalidate>
            <div
              class="grid grid-cols-1 lg:grid-cols-2 gap-y-[20px] gap-x-2.5 lg:gap-x-4 mb-[20px]"
            >
              <!-- First Name -->
              <div class="flex flex-col">
                <out-label
                  for="firstName"
                  labelText="First name"
                  class="font-medium pb-[4px] leading-[20px]"
                  [ngClass]="{
            'text-red-500':
              faqForm.get('firstName')?.invalid &&
              faqForm.get('firstName')?.touched,
          }"
                ></out-label>
                <input
                  id="firstName"
                  formControlName="firstName"
                  type="text"
                  class="border rounded-lg p-2 focus:outline-OUT-Blue focus:ring-0 focus:border-black"
                  [ngClass]="{
            'border-red-500 focus:border-red-600':
              faqForm.get('firstName')?.invalid &&
              faqForm.get('firstName')?.touched,
          }"
                />
                <span
                  *ngIf="
                    faqForm.get('firstName')?.invalid &&
                    faqForm.get('firstName')?.touched
                  "
                  class="text-red-500 mt-1"
                  >⚠ Must provide a first name.</span
                >
              </div>

              <!-- Last Name -->
              <div class="flex flex-col">
                <out-label
                  for="lastName"
                  labelText="Last name"
                  [ngClass]="{
            'text-red-500':
              faqForm.get('lastName')?.invalid &&
              faqForm.get('lastName')?.touched,
          }"
                  class="font-medium pb-[4px] leading-[20px]"
                ></out-label>
                <input
                  id="lastName"
                  formControlName="lastName"
                  type="text"
                  class="border rounded-lg p-2 focus:outline-OUT-Blue focus:ring-0 focus:border-black"
                  [ngClass]="{
            'border-red-500 focus:border-red-600':
              faqForm.get('lastName')?.invalid &&
              faqForm.get('lastName')?.touched,
          }"
                />
                <span
                  *ngIf="
                    faqForm.get('lastName')?.invalid &&
                    faqForm.get('lastName')?.touched
                  "
                  class="text-red-500 text-[12px] mt-1"
                  >⚠ Must provide a last name.</span
                >
              </div>
            </div>

            <section>
              <!-- Telephone -->
              <div class="flex flex-col mb-[20px]">
                <out-label
                  for="telephone"
                  labelText="Telephone"
                  class="font-medium pb-[4px] leading-[20px]"
                ></out-label>
                <input
                  id="telephone"
                  formControlName="telephone"
                  type="tel"
                  class="border rounded-lg p-2 focus:outline-OUT-Blue focus:border-black"
                />
              </div>

              <!-- Email -->
              <div class="mt-[25px] xl:mt-4 flex flex-col">
                <out-label
                  for="email"
                  labelText="Email"
                  class="font-medium pb-[4px] leading-[20px]"
                  [ngClass]="{
            'text-red-500':
              faqForm.get('email')?.invalid &&
              faqForm.get('email')?.touched,
          }"
                ></out-label>

                <div class="relative w-full">
                  <input
                    id="email"
                    formControlName="email"
                    type="email"
                    class="border rounded-lg p-2 focus:outline-OUT-Blue focus:ring-0 focus:border-black w-full"
                    [ngClass]="{
              'outline-red-500 focus:border-red-600':
                faqForm.get('email')?.invalid &&
                faqForm.get('email')?.touched,
            }"
                  />
                </div>
                <span
                  *ngIf="
                    faqForm.get('email')?.invalid &&
                    faqForm.get('email')?.touched
                  "
                  class="text-red-500 text-sm mt-1"
                  >⚠ Must provide an email.</span
                >
              </div>
            </section>

            <!-- Message -->
            <div class="mt-[20px] xl:mt-4 flex flex-col">
              <out-label
                for="message"
                labelText="Message"
                [ngClass]="{
          'text-red-500':
            faqForm.get('message')?.invalid &&
            faqForm.get('message')?.touched,
        }"
                class="font-medium pb-[4px] leading-[20px]"
              ></out-label>
              <textarea
                id="message"
                formControlName="message"
                class="border rounded-lg px-2 py-1 focus:outline-OUT-Blue focus:ring-0 focus:border-black"
                rows="4"
                [ngClass]="{
          'border-red-500 focus:border-red-600':
            faqForm.get('message')?.invalid &&
            faqForm.get('message')?.touched,
        }"
              ></textarea>
              <span
                *ngIf="
                  faqForm.get('message')?.invalid &&
                  faqForm.get('message')?.touched
                "
                class="text-red-500 text-sm mt-1"
                ><!-- Display error for required field -->
                <span *ngIf="faqForm.get('message')?.errors?.['required']">
                  ⚠ Must provide a message.
                </span>
                <!-- Display error for minlength -->
                <span *ngIf="faqForm.get('message')?.errors?.['minlength']">
                  ⚠ Message must be at least 30 characters long. </span
                >.</span
              >
            </div>

            <!-- Submit Button -->
            <div>
              <button
                [disabled]="faqForm.invalid || isSubmitting"
                type="submit"
                class="bg-OUT-Blue hover:bg-blue-600 transition-colors duration-300 text-white py-2.5 mt-4 xl:mt-4 rounded-lg w-full disabled:bg-OUT-Blue/80 disabled:cursor-default"
              >
                Submit Enquiry →
              </button>
            </div>
          </form>
        </section>
      </div>
    </div>
  </section>
</main>

<out-alert></out-alert>
